import { useState } from 'react';
import { NavLink } from 'react-router-dom';

/*
 * If we want to prevent the API calls from even starting until the user clicks the button for the first time,
 * we would need to modify useProject to accept an `enabled` parameter.
 * However, as currently written,
 * `useProject` will begin fetching as soon as the component mounts.
 * This is generally preferred for a snappier UI.
 */
import { useProjects } from '../../../hooks/api/useProjects';
import { ErrorNotice } from '../../../components/ErrorNotice';

export function ProjectsListLayout() {
  // Local state to handle the accordion toggle UI
  const [showProjects, setShowProjects] = useState(false);

  /*
   * Use the new React Query-based hook.
   * TanStack Query handles the load and the state automatically via isLoading and data.
   */
  const { data, isLoading, isError, error } = useProjects();

  const toggleVisibility = () => setShowProjects((prev) => !prev);

  const projects = data?.projects || [];

  return (
    <div>
      <button onClick={toggleVisibility}>
        Projects {showProjects ? '▾' : '▸'}
      </button>

      {showProjects && (
        <div style={{ marginLeft: '10px' }}>
          {isLoading ? (
            <p>Loading...</p>
          ) : isError ? (
            <ErrorNotice error={error} />
          ) : projects.length > 0 ? (
            projects.map((m) => (
              <NavLink key={m.uuid} to={`/dashboard/project/${m.uuid}`}>
                {`${m.uuid}`}
                <br />
              </NavLink>
            ))
          ) : (
            <p>No projects found.</p>
          )}
        </div>
      )}
    </div>
  );
}
